export default function BrandStory() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-8 md:gap-12">
          <div className="lg:w-2/3">
            <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-6"
              style={{ fontFamily: "var(--font-heading)" }}>
              品牌故事
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              韩漫网成立于2020年，是国内最早专注于韩国漫画在线阅读的中文平台之一。
              我们怀着对韩漫的无限热爱，致力于打破语言和地域的壁垒，让每一位中文读者都能
              无障碍地享受来自韩国的高质量漫画作品。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              经过多年的深耕发展，韩漫网已与多家韩国顶尖漫画出版社建立了稳固的合作关系，
              平台收录了超过5000部正版韩漫作品，涵盖武侠、奇幻、恋爱、悬疑、古风、校园等
              众多热门类型，满足不同读者的阅读偏好。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              我们拥有一支专业的翻译和运营团队，确保每一部作品的汉化质量达到行业领先水平，
              同时保持与韩国平台的同步更新速度，让读者不再为等待更新而焦虑。
            </p>
            <div className="flex items-center gap-12 md:gap-16">
              <div>
                <p className="text-3xl md:text-4xl font-black text-primary-500">6+</p>
                <p className="text-xs text-foreground-400 mt-1">年行业深耕</p>
              </div>
              <div>
                <p className="text-3xl md:text-4xl font-black text-primary-500">5000+</p>
                <p className="text-xs text-foreground-400 mt-1">正版韩漫收录</p>
              </div>
              <div>
                <p className="text-3xl md:text-4xl font-black text-primary-500">500万+</p>
                <p className="text-xs text-foreground-400 mt-1">活跃读者</p>
              </div>
            </div>
          </div>

          <div className="lg:w-1/3">
            <div className="relative overflow-hidden rounded-lg aspect-[3/4] max-w-[260px] mx-auto lg:mx-0">
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20library%20reading%20space%2C%20warm%20lighting%2C%20cozy%20atmosphere%2C%20books%20and%20digital%20screens%2C%20modern%20Korean%20aesthetic%2C%20inviting%20mood&width=600&height=800&seq=about-brand-01&orientation=portrait"
                alt="韩漫网品牌形象"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute top-3 left-3">
                <span className="bg-white text-foreground-900 text-xs font-medium px-3 py-1 rounded-full whitespace-nowrap">
                  品质保证
                </span>
              </div>
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                <p className="text-white text-sm font-semibold whitespace-nowrap">韩漫网</p>
                <p className="text-white/70 text-xs whitespace-nowrap">高清韩国漫画阅读平台</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}